import { App, ObjectDirective } from 'vue';
import VueResizeObserver from 'vue-resize-observer';

const directives: Record<string, ObjectDirective> = {
  resize: VueResizeObserver,
};

export default {
  install(app: App) {
    Object.keys(directives).forEach((key) => {
      app.directive(key, directives[key]);
    });
  },
};
